{
  "labels": {
    "textSingleLine": "Text - Single Line",
    "textMultipleLines": "Text - Multiple Lines",
    "date": "Date",
    "trueFalse": "True/False",
    "singleDocument": "Single Document",
    "multiDocument": "Multi Document",
    "number": "Number",
    "eMail": "E-mail",
    "phone": "Phone",
    "dropDownSingleSelectList": "Drop-down Single Select List",
    "dropDownMultiSelectList": "Drop-down Multi Select List",
    "comboBox": "Combo Box",
    "timestamp": "Timestamp",
    "featureLink": "Feature Link"
  },
  "descriptions": {
    "openTextFieldSingleLine": "Open text field, single line",
    "openTextFieldMultipleLines": "Open text field, multiple lines",
    "formatMmDdYyyy": "Format MM/DD/YYYY",
    "toggleButton": "Toggle Button",
    "singleFileUploadField": "Single file upload field",
    "multipleFileUploadField": "Multiple file upload field",
    "numericInputField": " Numeric input field",
    "emailAddressInputField": "Email address input field",
    "format1XxxXxxXxxx": "Format +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "Select one option from a list",
    "selectMultipleOptionsFromAList": "Select multiple options from a list",
    "singleOptionDropDownListOpenTextField": "Single option drop-down list + open text field",
    "dateAndTimeFields": "Date and time fields",
    "linkToTheFormFeatures": "Link to the form features"
  }
}
